import React from 'react'

const FaqPage = () => {
  const faqs = [
    {
      q: 'How do I find events and offers on Obule?',
      a: 'You can browse curated events and offers directly from the landing page or by visiting the Offers page. Use filters such as location, dates, and availability to narrow your search.'
    },
    {
      q: 'Where can I see my tickets after purchase?',
      a: 'Tickets and offer confirmations are emailed to you and can also be found in your attendee dashboard under the Tickets and Orders sections.'
    },
    {
      q: 'How are payments processed?',
      a: 'Payments are processed securely by our payment partner. We do not store full card details on our servers, and transactions are encrypted from end to end.'
    }
  ]

  return (
    <main className="min-h-screen bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <header className="mb-10 sm:mb-14">
          <p className="text-sm font-semibold text-emerald-600 mb-2 uppercase tracking-wide">
            FAQs
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-slate-900 mb-4 leading-tight">
            Frequently asked questions
          </h1>
          <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-3xl font-light">
            Here are some quick answers to common questions about using Obule as both an attendee
            and an organizer.
          </p>
        </header>

        <div className="space-y-6">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className="p-6 rounded-2xl bg-white shadow-sm border border-slate-200"
            >
              <h2 className="text-lg font-semibold text-slate-900 mb-2">{item.q}</h2>
              <p className="text-base text-slate-600 leading-relaxed font-light">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  )
}

export default FaqPage

